import { AssignmentTurnedIn as AssignmentTurnedInIcon } from '@mui/icons-material';
import { childrenReturnsIntakePageSummariesBreadcrumbs } from '../../config';
import { LoaderBackdrop, NavigateLinks } from '@/components';
import { useReturnsIntakeScannerSummary } from '../../hooks';
import { useNavigate } from 'react-router-dom';
import { useMemo, useState } from 'react';
import {
  SummaryHeader,
  SummaryList,
  SummaryBrief,
  SummaryFooter,
  ConfirmationModal,
} from '../../components';

const ReturnsIntakeScannerSummary = () => {
  const navigate = useNavigate();
  const {
    shippings,
    isLoading,
    activeTab,
    handleTabChange,
    handleFinish,
    driverName,
    driverId,
    stats,
    explanations,
    handleGoToStart,
  } = useReturnsIntakeScannerSummary();

  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const breadcrumbs = useMemo(
    () => childrenReturnsIntakePageSummariesBreadcrumbs(navigate),
    [navigate]
  );

  const handleOpenConfirm = () => setIsConfirmModalOpen(true);
  const handleCloseConfirm = () => setIsConfirmModalOpen(false);

  const handleConfirmFinish = () => {
    handleCloseConfirm();
    handleFinish();
  };

  const emptyMessages = [
    'No hay pedidos devueltos',
    'No hay pedidos inesperados',
    'No hay pedidos no reportados',
  ];

  return (
    <section className='flex flex-col w-full h-full gap-8 mb-12'>
      <NavigateLinks
        actualPage='Resumen de Rendición'
        breadcrumbs={breadcrumbs}
      />
      {isLoading && <LoaderBackdrop />}

      <section className='w-full flex flex-col gap-6'>
        <SummaryBrief
          driverName={driverName}
          driverId={driverId}
          routeLabel='Resumen de Actividad'
          title='Resumen de Rendición'
          onFinish={handleOpenConfirm}
          isProcessing={isLoading}
        />
        <div className='flex flex-col'>
          <SummaryHeader
            compliances={stats}
            explanations={explanations}
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />
          <div className='bg-white rounded-b-xl rounded-tr-xl border border-gray-200 flex flex-col overflow-hidden'>
            <div className='p-6'>
              <SummaryList
                shippings={shippings}
                isLoading={isLoading}
                emptyMessage={
                  emptyMessages[activeTab] || 'No hay pedidos en esta categoría'
                }
              />
            </div>
          </div>
        </div>
        <SummaryFooter
          onFinish={handleOpenConfirm}
          onGoToStart={handleGoToStart}
          isProcessing={isLoading}
          compliances={stats}
        />
      </section>

      <ConfirmationModal
        open={isConfirmModalOpen}
        onClose={handleCloseConfirm}
        onConfirm={handleConfirmFinish}
        title='Cerrar Rendición'
        icon={AssignmentTurnedInIcon}
        confirmLabel='Cerrar Rendición'
        description='¿Está seguro de que desea cerrar la rendición actual? Esta acción no se puede deshacer.'
        isProcessing={isLoading}
      />
    </section>
  );
};

export default ReturnsIntakeScannerSummary;
